export const types = <const>{
	mutations: {
		PRACOVNIK_SELECT_MAPPER: 'pracovnikSelectMapper',
		ZAKAZKA_SELECT_MAPPER: 'zakazkaSelectMapper',
	},
};
